import { Controller } from "@hotwired/stimulus"

// JUDGING A LIST WITHOUT REACHING FOR THE MOUSE.
//
// 684 findings is a long afternoon, and the difference between a review that
// gets finished and one abandoned halfway is often just how far your hand has
// to travel. A / J moves down, K up, and the current row is the one you act
// on.
//
// SCOPED TO THE LIST, not the document: a page with a text field in it must
// not have "j" mean "next row" while somebody is typing a weight into it. The
// guard below is why.
export default class extends Controller {
  static targets = ["row"]
  static classes = ["current"]

  connect() {
    this.index = 0
    this.onKey = this.handleKey.bind(this)
    document.addEventListener("keydown", this.onKey)
    this.mark()
  }

  disconnect() {
    document.removeEventListener("keydown", this.onKey)
  }

  handleKey(event) {
    // Never while somebody is typing, and never over a browser shortcut.
    if (event.metaKey || event.ctrlKey || event.altKey) return
    const tag = event.target.tagName
    if (tag === "INPUT" || tag === "TEXTAREA" || event.target.isContentEditable) return

    switch (event.key) {
      case "j":
      case "ArrowDown":
        event.preventDefault()
        this.move(1)
        break
      case "k":
      case "ArrowUp":
        event.preventDefault()
        this.move(-1)
        break
      case "a":
        event.preventDefault()
        this.press("approve")
        break
      case "r":
        event.preventDefault()
        this.press("reject")
        break
    }
  }

  move(by) {
    if (this.rowTargets.length === 0) return

    this.index = Math.max(0, Math.min(this.rowTargets.length - 1, this.index + by))
    this.mark()
    this.rowTargets[this.index].scrollIntoView({ block: "nearest", behavior: "smooth" })
  }

  mark() {
    this.rowTargets.forEach((row, i) => {
      row.classList.toggle(this.currentClass, i === this.index)
    })
  }

  // The row's own button, so a shortcut and a click go through exactly the
  // same path — a keyboard route that posted its own request would be a
  // second way to decide, drifting from the first.
  press(action) {
    const row = this.rowTargets[this.index]
    if (!row) return

    const button = row.querySelector(`[data-review-action="${action}"] button`)
    if (button) button.click()
  }
}
